import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { mensagemDeErro } from '../services/api';

const dinheiro = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const dataHora = (v) => (v ? String(v).slice(0, 16).replace('T', ' ') : '—');

// Cada estado do pedido com a cara que ele deve ter na lista.
const ESTADOS = {
  RASCUNHO:              { rotulo: 'Rascunho',              classe: 'badge-neutro',   icone: 'pencil' },
  AGUARDANDO_LIBERACAO:  { rotulo: 'Aguardando liberação',  classe: 'badge-pendente', icone: 'shield-exclamation' },
  AGUARDANDO_INTEGRACAO: { rotulo: 'Aguardando integração', classe: 'badge-pendente', icone: 'hourglass-split' },
  INTEGRANDO:            { rotulo: 'Enviando',              classe: 'badge-pendente', icone: 'arrow-repeat' },
  INTEGRADO:             { rotulo: 'No Microuniverso',      classe: 'badge-positivo', icone: 'check2-circle' },
  DIVERGENTE:            { rotulo: 'Sem resposta do ERP',   classe: 'badge-negativo', icone: 'exclamation-triangle' },
  ERRO_INTEGRACAO:       { rotulo: 'Erro na integração',    classe: 'badge-negativo', icone: 'x-circle' },
  CANCELADO:             { rotulo: 'Cancelado',             classe: 'badge-neutro',   icone: 'slash-circle' },
};

export default function MeusPedidos() {
  const navigate = useNavigate();
  const [pedidos, setPedidos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  const [filtro, setFiltro] = useState('');

  useEffect(() => {
    api.get('/api/pedidos', { params: filtro ? { status: filtro } : {} })
      .then((r) => setPedidos(r.data.pedidos))
      .catch((e) => setErro(mensagemDeErro(e)))
      .finally(() => setCarregando(false));
  }, [filtro]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
        <div>
          <h1 className="h4 fw-bold mb-1">Pedidos</h1>
          <p className="text-muted small mb-0">
            Os orçamentos do Fênix, com o número que cada um recebeu no Microuniverso.
          </p>
        </div>
        <select className="form-select form-select-sm" style={{ width: 220 }}
                value={filtro} onChange={(e) => { setCarregando(true); setFiltro(e.target.value); }}>
          <option value="">Todos os status</option>
          {Object.entries(ESTADOS).map(([k, v]) => <option key={k} value={k}>{v.rotulo}</option>)}
        </select>
      </div>

      {erro && <div className="alert alert-danger py-2 small">{erro}</div>}

      <div className="card">
        <div className="table-responsive">
          <table className="table table-fnx mb-0">
            <thead>
              <tr>
                <th>Número</th><th>Cliente</th><th>Filial</th>
                <th className="text-end">Itens</th><th className="text-end">Total</th>
                <th>Status</th><th>Nº no ERP</th><th>Criado</th>
              </tr>
            </thead>
            <tbody>
              {carregando && (
                <tr><td colSpan={8} className="text-center py-4 text-muted">
                  <span className="spinner-border spinner-border-sm me-2" />Carregando…
                </td></tr>
              )}
              {!carregando && pedidos.length === 0 && (
                <tr><td colSpan={8} className="text-center py-5 text-muted">
                  <i className="bi bi-receipt display-6 d-block mb-2 opacity-50" />
                  Nenhum pedido ainda.
                </td></tr>
              )}
              {pedidos.map((p) => {
                const e = ESTADOS[p.status] || ESTADOS.RASCUNHO;
                return (
                  <tr key={p.uuid} className="linha-clicavel"
                      onClick={() => navigate(`/pedidos/${p.uuid}`)}
                      title="Abrir o orçamento">
                    <td className="fw-semibold">{p.numero}</td>
                    <td>{p.cliente_razao || <span className="text-muted">—</span>}</td>
                    <td><span className="badge badge-filial">{p.filial_venda}</span></td>
                    <td className="text-end">{p.qtd_itens}</td>
                    <td className="text-end fw-semibold">{dinheiro(p.valor_liquido)}</td>
                    <td>
                      <span className={`badge ${e.classe}`}>
                        <i className={`bi bi-${e.icone} me-1`} />{e.rotulo}
                      </span>
                    </td>
                    <td>
                      {p.numped_erp
                        ? (<>
                            {p.numped_erp}
                            {p.integracao_manual === 1 && (
                              <i className="bi bi-keyboard ms-1 text-muted"
                                 title="Digitado manualmente no ERP" />
                            )}
                          </>)
                        : <span className="text-muted">—</span>}
                    </td>
                    <td className="small text-muted">{dataHora(p.criado_em)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
